import React from 'react'

class Sent extends React.Component {
  render() {
    return (
      <svg data-testid="sent-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <defs>
          <filter id="kctlzfolia" colorInterpolationFilters="auto">
            <feColorMatrix
              in="SourceGraphic"
              values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
            />
          </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g>
            <g>
              <g>
                <g
                  filter="url(#kctlzfolia)"
                  transform="translate(-340.000000, -669.000000) translate(328.000000, 508.000000) translate(12.000000, 158.000000) translate(0.000000, 3.000000)"
                >
                  <g fillRule="nonzero">
                    <path
                      stroke="#000"
                      strokeWidth="2"
                      d="M18.776 1.225l-6.847 17.334-3.333-7.177L1.444 8.07l17.332-6.845z"
                      transform="translate(1.000000, 1.000004)"
                    />
                    <path
                      fill="#000"
                      d="M12.573 -0.313L13.906 -0.312 13.906 13.688 12.573 13.688z"
                      transform="translate(1.000000, 1.000004) translate(13.239779, 6.687494) rotate(-315.000000) translate(-13.239779, -6.687494)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export default Sent
